export const onlyNumbers = (_string) => _string?.replace(/[^0-9.,+-]+/g, "")
export const onlyUnsignedNumbers = (_string) => _string?.replace(/[^0-9]+/g, "")

export const onlyDecimal = (_string) => {
  const match = _string.match(/^[0-9]*\.?[0-9]*$/)
  if (match) return _string
  else return _string.substring(0, _string.length - 1)
}
export const ConvertMoney = (string) => {
  string = Number(string)
  string = string?.toLocaleString("pt-BR", { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })
  return string
}
export const isValidCnpj = (cnpj_string) => {
  cnpj_string = onlyUnsignedNumbers(cnpj_string)
  if (cnpj_string === "") return false
  // Elimina CNPJ_strings invalidos conhecidos
  if (
    cnpj_string.length !== 14 ||
    cnpj_string === "00000000000000" ||
    cnpj_string === "11111111111111" ||
    cnpj_string === "22222222222222" ||
    cnpj_string === "33333333333333" ||
    cnpj_string === "44444444444444" ||
    cnpj_string === "55555555555555" ||
    cnpj_string === "66666666666666" ||
    cnpj_string === "77777777777777" ||
    cnpj_string === "88888888888888" ||
    cnpj_string === "99999999999999"
  ) {
    return false
  }

  let tamanho = cnpj_string.length - 2
  let numeros = cnpj_string.substring(0, tamanho)
  const digitos = cnpj_string.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }
  let resultado = String(soma % 11 < 2 ? 0 : 11 - (soma % 11))
  if (resultado !== digitos.charAt(0)) return false
  tamanho = tamanho + 1
  numeros = cnpj_string.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }
  resultado = String(soma % 11 < 2 ? 0 : 11 - (soma % 11))
  if (resultado !== digitos.charAt(1)) return false
  return true
}

export const isValidCpf = (cpf_string) => {
  cpf_string = onlyNumbers(cpf_string)
  if (cpf_string === "") return false
  if (
    cpf_string.length !== 11 ||
    cpf_string === "00000000000" ||
    cpf_string === "11111111111" ||
    cpf_string === "22222222222" ||
    cpf_string === "33333333333" ||
    cpf_string === "44444444444" ||
    cpf_string === "55555555555" ||
    cpf_string === "66666666666" ||
    cpf_string === "77777777777" ||
    cpf_string === "88888888888" ||
    cpf_string === "99999999999"
  ) {
    return false
  }
  // Valida 1o digito
  let add = 0
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf_string.charAt(i)) * (10 - i)
  }
  let rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf_string.charAt(9))) {
    return false
  }

  // Valida 2o digito
  add = 0
  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf_string.charAt(i)) * (11 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf_string.charAt(10))) {
    return false
  }
  return true
}

export const cpfMask = (cpfCnpj) => {
  if (cpfCnpj === null || cpfCnpj === undefined) return
  cpfCnpj = onlyUnsignedNumbers(cpfCnpj)

  return String(cpfCnpj)
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1")
}
export const cnpjMask = (cpfCnpj) => {
  if (cpfCnpj === null || cpfCnpj === undefined) return
  cpfCnpj = onlyUnsignedNumbers(cpfCnpj)
  return String(cpfCnpj)
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1")
}

export const phoneMaskForList = (phone, ddi) => {
  if (phone === null || phone === undefined) return

  phone = onlyUnsignedNumbers(phone)

  if (ddi !== "55") {
    return phone
  }

  // Verifica o comprimento do número
  if (phone.length !== 11) {
    // Máscara para números fora do formato esperado
    return String(phone)
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d{4})$/, "$1-$2")
  }
  
  // Máscara padrão para números com 11 dígitos
  return String(phone)
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .replace(/(-\d{4})\d+?$/, "$1")
}

export const cpfCnpjMask = (cpfCnpj) => {
  if (cpfCnpj === null || cpfCnpj === undefined) return
  cpfCnpj = onlyUnsignedNumbers(cpfCnpj)
  if (String(cpfCnpj).length < 11) {
    return cpfCnpj
  }
  if (String(cpfCnpj).length === 11) {
    const result = String(cpfCnpj)
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1")
    return result
  }
  if (String(cpfCnpj).length >= 12) {
    cpfCnpj = cpfCnpj.slice(-14)
    const result = String(cpfCnpj)
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1")
    return result
  }

}


export const cepMask = (cpfCnpj) => {
  if (cpfCnpj === null || cpfCnpj === undefined) return
  cpfCnpj = onlyUnsignedNumbers(cpfCnpj)
  return String(cpfCnpj)
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .replace(/(-\d{3})\d+?$/, "$1")
}

export const dateLastAccess = (data) => {
  if (data === null || data === undefined) return
  data = data?.split(" ")
  let days = data[0]?.split("-")
  days = `${days[2]} / ${days[1]} / ${days[0]}`
  return days
}

export const percentageMask = (number) => {
  return number.replace(/[^0-9,.]+/g, "").replace(/([0-9,.]+?$)/, "$1%")
}


/**
 * Cota de consórcio. O back valida `^\d{1,10}(-\d{1,2})?$` e normaliza para o
 * formato canônico (`1234` -> `1234-00`, `1234-5` -> `1234-05`), então aqui só
 * limitamos o que pode ser digitado: dígitos, um traço opcional e até 2 dígitos
 * depois dele. Sem padding de zeros à esquerda — `12` é `12-00`, não `0012-00`.
 */
export const cotaMask = (value) => {
  // A barra é o erro de digitação natural do separador ("1234/5"): virar traço
  // preserva a intenção, enquanto apagá-la daria outra cota ("12345").
  const cleaned = String(value ?? '')
    .replace(/\//g, '-')
    .replace(/[^\d-]/g, '')
  const [numeroBruto = '', ...resto] = cleaned.split('-')
  const numero = numeroBruto.slice(0, 10)

  if (!numero) return ''
  if (!resto.length) return numero

  return `${numero}-${resto.join('').replace(/\D/g, '').slice(0, 2)}`
}

// A máscara aceita o traço solto enquanto o usuário digita ("1234-"); no envio
// ele sai, senão o back devolve 422.
export const cotaForPayload = (value) => cotaMask(value).replace(/-$/, '')

/**
 * Percentual de 0 a 100 com até 2 decimais — o `valor_lance` do consórcio, que
 * deixou de ser valor em reais e passou a ser o percentual sobre a carta.
 * Vírgula como separador decimal. Acima de 100 o valor é preso no teto, porque
 * fora da faixa o back devolve 422.
 */
export const percentMask = (value) => {
  const cleaned = String(value ?? '')
    .replace(/\./g, ',')
    .replace(/[^\d,]/g, '')

  if (!cleaned) return ''

  const temVirgula = cleaned.includes(',')
  const [inteiroBruto = '', ...resto] = cleaned.split(',')
  const inteiro = inteiroBruto.replace(/^0+(?=\d)/, '').slice(0, 3)
  const decimais = resto.join('').replace(/\D/g, '').slice(0, 2)

  if (Number(`${inteiro || '0'}.${decimais || '0'}`) > 100) return '100'

  return temVirgula ? `${inteiro || '0'},${decimais}` : inteiro
}

// A máscara aceita a vírgula solta enquanto o usuário digita ("20,"); no envio
// vira número. Vazio vai como null.
export const percentForPayload = (value) => {
  const masked = percentMask(value)
  if (!masked) return null

  const numero = Number(masked.replace(',', '.'))
  return Number.isNaN(numero) ? null : numero
}

// LIB-1808 - a caixa de contrato aceita vários destinatários no mesmo campo,
// separados por ponto e vírgula. Quebra a string no que o usuário digitou e
// descarta os espaços em branco entre um e-mail e outro.
export const splitEmailList = (value) =>
  String(value ?? '')
    .split(';')
    .map((email) => email.trim())
    .filter(Boolean)

// Validação de formato, não de existência: o que importa aqui é barrar o erro
// de digitação antes de o contrato sair. A vírgula fica de fora do conjunto de
// propósito, para que "a@x.com,b@y.com" caia como inválido em vez de ir para o
// provedor de assinatura como um endereço só.
export const isValidEmail = (email) =>
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(
    String(email ?? '').trim()
  )
